
export const statusEnum = [
  { value: undefined, label: '全部' },
  { value: 1, label: '已提交', color: '#EF8D3C', desc: '' },
  { value: 2, label: '已确认', color: '#3FAC46', desc: '' }
]
